import { render, staticRenderFns } from "./cDDashboard.vue?vue&type=template&id=57bd4ab8&scoped=true"
import script from "./cDDashboard.vue?vue&type=script&lang=js"
export * from "./cDDashboard.vue?vue&type=script&lang=js"
import style0 from "./cDDashboard.vue?vue&type=style&index=0&id=57bd4ab8&prod&scoped=true&lang=scss"
import style1 from "./cDDashboard.vue?vue&type=style&index=1&id=57bd4ab8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bd4ab8",
  null
  
)

export default component.exports